/**
 * GateModalHost — Phase 3.
 *
 * Listens for 'ovacs:gate_blocked' window events (emitted by the axios
 * response interceptor when a 402 with `gate` payload comes back) and
 * shows the GateModal. One host renders globally inside App.jsx.
 */

import { useEffect, useState } from 'react'
import GateModal from './GateModal'

export default function GateModalHost() {
  const [gate, setGate] = useState(null)

  useEffect(() => {
    const onGate = (event) => {
      const detail = event.detail || {}
      setGate({
        reason: detail.reason || '',
        message: detail.message || 'This action is not allowed.',
        hintAction: detail.hint_action || null,
        ctaUrl: detail.cta_url || null,
        severity: detail.severity || 'error',
      })
    }
    window.addEventListener('ovacs:gate_blocked', onGate)
    return () => window.removeEventListener('ovacs:gate_blocked', onGate)
  }, [])

  return (
    <GateModal
      open={!!gate}
      reason={gate?.reason}
      message={gate?.message}
      hintAction={gate?.hintAction}
      ctaUrl={gate?.ctaUrl}
      severity={gate?.severity}
      onClose={() => setGate(null)}
    />
  )
}
